<template>
    <thead>
        <tr>
            <th
                v-for="(column, i) in columns"
                :key="i"
                :style="`${column.checked == 1 ? '' : 'display:none'}`"
                scope="col"
            >
                <div
                    v-if="column.checked == 1"
                    class="p-0 col-md col-sm-12 d-flex justify-content-start"
                >
                    <span
                        class="th-text font-weight-bold text-left col-auto"
                        v-if="column.search == false && column.label"
                        >{{ column.label }}</span
                    >

                    <form-select-group
                        v-if="column.search && column.type == 'select'"
                        v-model="column.searchModel"
                        class="px-0 mb-0"
                        @click="$emit('click-search-line')"
                        @close="$emit('clear')"
                        @selected="
                            search(
                                column.name,
                                getNameSelected(
                                    column.searchModel,
                                    column.options
                                ),
                                i,
                                'select'
                            )
                        "
                        :itens="column.options"
                        btnClass="btn-sort text-secondary float-right ml-0 px-1"
                        :btnIcon="
                            sortSelected == `sort-${column.id}`
                                ? sortStatus
                                    ? 'mdi mdi-sort-ascending'
                                    : 'mdi mdi-sort-descending'
                                : 'mdi mdi-sort-descending'
                        "
                        @submit="
                            sort(i);
                            sortSelected = `sort-${column.id}`;
                        "
                    />
                    <form-input-group
                        type="date"
                        v-model="column.searchModel"
                        :placeholder="column.label"
                        v-if="column.search && column.type == 'data'"
                        class="px-0"
                        @click="$emit('click-search-line')"
                        @input="search(column.name, column.searchModel, i)"
                        :isButton="column.filter"
                        btnClass="btn-sort text-secondary float-right ml-0 px-1"
                        :iconBtn="
                            sortSelected == `sort-${column.id}`
                                ? sortStatus
                                    ? 'mdi mdi-sort-ascending'
                                    : 'mdi mdi-sort-descending'
                                : 'mdi mdi-sort-descending'
                        "
                        @submit="
                            sort(i);
                            sortSelected = `sort-${column.id}`;
                        "
                    />
                    <form-input-group
                        type="search"
                        v-model="column.searchModel"
                        :placeholder="column.label"
                        v-if="column.search && column.type == 'input'"
                        class="px-0"
                        @click="$emit('click-search-line')"
                        @input="search(column.name, column.searchModel, i)"
                        :isButton="column.filter"
                        btnClass="btn-sort text-secondary float-right ml-0 px-1"
                        :iconBtn="
                            sortSelected == `sort-${column.id}`
                                ? sortStatus
                                    ? 'mdi mdi-sort-ascending'
                                    : 'mdi mdi-sort-descending'
                                : 'mdi mdi-sort-descending'
                        "
                        @submit="
                            sort(i);
                            sortSelected = `sort-${column.id}`;
                        "
                    />
                </div>
            </th>
            <th class="py-1 d-flex justify-content-end border-0">
                <div
                    class="dropdown dropdown-animated mt-3"
                    :class="showConfig && clickConfig ? 'show' : ''"
                    @click="
                        clickConfig = true;
                        showConfig = true;
                    "
                    @mouseleave="
                        showConfig = !showConfig;
                        clickConfig = false;
                    "
                    style="position: absolute"
                >
                    <a
                        @click="showConfig = !showConfig"
                        class="dropdown-toggle rounded px-1 float-right"
                        aria-expanded="true"
                    >
                        <i class="mdi mdi-cog"></i>
                    </a>

                    <div
                        class="card card-body border rounded p-3"
                        v-if="showConfig && clickConfig"
                        style="z-index: 10"
                    >
                        <div class="row">
                            <div class="col-12">
                                <a
                                    class="d-flex justify-content-between border-bottom"
                                >
                                    <span>Colunas</span>
                                    <i class="mdi mdi-checkbox-marked-outline">
                                    </i>
                                </a>
                            </div>
                            <div
                                v-for="(col, i) in columns"
                                :key="i"
                                class="col-12"
                            >
                                <a class="d-flex justify-content-between">
                                    <span>{{ col.label }}</span>
                                    <form-toggle
                                        grid="2"
                                        class="px-0"
                                        @click="checkColum(i)"
                                        v-model="columns[i].checked"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </th>
        </tr>
    </thead>
</template>

<script>
export default {
    name: "Header",
    props: {
        columns: { type: Array },
    },
    data() {
        return {
            showConfig: false,
            clickConfig: false,
            index: 0,
            value: 0,
            column: 0,
            sortSelected: "",
            sortStatus: false,
        };
    },
    mounted() {},
    methods: {
        sort(index) {
            this.$emit("sort", index);
            this.sortStatus = !this.sortStatus;
        },
        getNameSelected(valor, array) {
            const result = array.filter((item) => item.id === valor);
            return result[0] ? result[0].value : "";
        },
        search(index, value, column, type = "input") {
            this.index = index;
            this.value = value;
            this.column = column;
            if (type == "input") {
                this.emitSearch(index, value, column);
            } else {
                this.$emit("search", index, value, column);
            }
        },
        emitSearch: function emitSearch(index, value, column) {
            if (value != "") {
                clearTimeout(emitSearch.timeout);
                emitSearch.timeout = setTimeout(() => {
                    //console.log("teste");
                    this.$emit("search", index, value, column);
                }, 1000);
            } else {
                this.$emit("clear");
            }
        },
    },
    components: {},
    computed: {},
};
</script>

<style scoped>
.btn-sort {
    cursor: pointer;
    padding-top: 13px;
}
.th-text {
    float: left;
    width: 85%;
    padding: 10px;
    height: calc(1.5em + 0.75rem + 2px);
    padding-right: 15px;
}
/* select,
input {
    float: left;
    width: 85%;
    padding: 10px;
    padding-bottom: 0;
    height: calc(1.5em + 0.75rem + 2px);
    border: 0;
    border-bottom: 1px solid gray;
}
select:focus,
input:focus {
    border: 0;
    border-bottom: 1px solid #4099ff;
} */
.table:not(.table-dark):not(.table-light) thead:not(.table-dark) th {
    background-color: white !important;
}
</style>
